import Axios from "axios";

const instance = Axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: process.env.REACT_APP_CLIENT_PASSWORD_FOR_CLIENT_AUTH !== undefined ? {
    common: {
      'X-Custom-Client-Auth': process.env.REACT_APP_CLIENT_PASSWORD_FOR_CLIENT_AUTH
    }
  } : undefined
});

export default instance;